import { SkeletonLoaderProps } from './skeleton-loader';

export const Skeleton = ({
  repeat,
  type,
}: Required<
  Omit<SkeletonLoaderProps, 'status' | 'children' | 'errorRender' | 'error'>
>) => {
  let SkeletonRender: React.ComponentType = NormalSkeleton;
  switch (type) {
    case 'line':
      SkeletonRender = LineSkeleton;
      break;
    default:
      SkeletonRender = NormalSkeleton;
  }
  return (
    <>
      {Array.from({ length: repeat }, (_, i) => (
        <SkeletonRender key={i} />
      ))}
    </>
  );
};

const NormalSkeleton = () => (
  <div className="z-0 m-4 flex flex-row items-center space-x-5 overflow-hidden">
    <div className="h-12 w-12 max-w-[calc(100%-48px)] flex-shrink-0 rounded-full bg-gray-300 dark:bg-gray-600" />
    <div className="flex flex-shrink-0 flex-col space-y-3">
      <div className="h-6 w-96 max-w-[calc(100%-84px)] rounded-md bg-gray-300 dark:bg-gray-600" />
      <div className="h-6 w-44 max-w-[calc(100%-84px)] rounded-md bg-gray-300 dark:bg-gray-600" />
    </div>
  </div>
);

const widths = ['w-96', 'w-72', 'w-52', 'w-44'];

const LineSkeleton = () => {
  return (
    <div
      className={`${
        widths[(Math.random() * widths.length) | 0]
      } z-0 m-4 h-6 max-w-[calc(100%-38px)] rounded-md bg-gray-300 dark:bg-gray-600`}
    ></div>
  );
};
